<script lang="ts" setup>
import FavoriteStarPulse from './FavoriteStarPulse.vue';

const props = withDefaults(
	defineProps<{
		isReady: boolean;
		isSelected: boolean;
		isAnimating: boolean;
		isMainPulsing?: boolean;
		isBackgroundPulsing?: boolean;
		showLabel?: boolean;
		showLabelOnMobile?: boolean;
	}>(),
	{
		showLabel: true,
		showLabelOnMobile: false
	}
);

const emit = defineEmits<{ (e: 'toggle'): void }>();

const labelText = computed(() => (props.isSelected ? 'Salvo' : 'Salvar'));
const labelVisibilityClass = computed(() =>
	props.showLabelOnMobile ? 'inline' : 'hidden sm:inline'
);

const ariaLabel = computed<string>(() =>
	props.isSelected ? 'Remover da minha coleção' : 'Adicionar à minha coleção'
);
</script>

<template>
	<Button
		v-if="props.isReady"
		variant="transparent"
		:is-client-only="false"
		:is-skeleton-loading="false"
		:class="[
			'absolute right-0 top-1/2 flex size-11 shrink-0 -translate-y-1/2 items-center justify-center gap-2 rounded-[2px] px-0 text-sm font-medium leading-5 transition-transform ease-out [transition-duration:1400ms] sm:h-11 sm:w-[124px] sm:px-4 sm:py-2',
			props.isSelected
				? 'border-0 bg-beige text-primary'
				: 'border border-white-dark-3 bg-white text-primary hover:bg-white-dark-1',
			props.isAnimating
				? 'translate-x-0 opacity-100'
				: 'translate-x-full opacity-0'
		]"
		:aria-label="ariaLabel"
		:aria-pressed="isSelected"
		@click.stop.prevent="emit('toggle')"
	>
		<FavoriteStarPulse
			:is-selected="props.isSelected"
			:is-main-pulsing="props.isMainPulsing ?? false"
			:is-background-pulsing="props.isBackgroundPulsing ?? false"
		/>
		<span
			v-if="props.showLabel"
			:class="[
				'text-sm font-medium leading-5 text-primary',
				labelVisibilityClass
			]"
			>{{ labelText }}</span
		>
	</Button>
</template>
